import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { getCachedProfile, getProfile, UserProfile } from 'src/services/profile';

interface AuthProfileContextProps {
  profile: UserProfile | null;
  loading: boolean;
  refresh: () => Promise<void>;
  setProfileValue: (profile: UserProfile | null) => void;
}

const AuthProfileContext = createContext<AuthProfileContextProps>({
  profile: null,
  loading: true,
  refresh: async () => {},
  setProfileValue: () => {},
});

interface ProviderProps {
  children: ReactNode;
}

export function AuthProfileProvider({ children }: ProviderProps) {
  const [profile, setProfile] = useState<UserProfile | null>(() => getCachedProfile());
  const [loading, setLoading] = useState(true);

  const loadProfile = async () => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (!token) {
      setProfile(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const data = await getProfile();
      setProfile(data);
    } catch (error) {
      console.error('Erro ao carregar perfil', error);
      const cached = getCachedProfile();
      setProfile(cached);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProfile();
  }, []);

  return (
    <AuthProfileContext.Provider value={{ profile, loading, refresh: loadProfile, setProfileValue: setProfile }}>
      {children}
    </AuthProfileContext.Provider>
  );
}

export function useAuthProfile() {
  return useContext(AuthProfileContext);
}
